import { Int64Updater } from 'src/app/helpers/key-value';
import { TriggerDefinition } from './../../models/trigger-definition';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Urls } from 'src/app/helpers/urls';

@Injectable({
  providedIn: 'root'
})
export class TriggerService {

  url = new Urls();
  apiUrl: string;

  constructor(
    private httpclient: HttpClient
  ) {
      this.apiUrl = this.url.apiUrl;
  }

  getTriggers(trigid, trigname, trigtype, next) {
    // tslint:disable-next-line: max-line-length
    const url = this.apiUrl + '/api/triggerdefinition/' + trigid + '/' + trigname + '/' + trigtype + '/' + next + '/';
    return this.httpclient.get<any>(url)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  postTriggers(trigger: TriggerDefinition) {
    // tslint:disable-next-line: max-line-length
    const url = this.apiUrl + '/api/triggerdefinition';
    return this.httpclient.post<any>(url, trigger)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  putTriggers(val: Int64Updater) {
    // tslint:disable-next-line: max-line-length
    const url = this.apiUrl + '/api/triggerdefinition/' + val.Id;
    return this.httpclient.put<any>(url, val)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  deleteTriggers(id: number) {
    // tslint:disable-next-line: max-line-length
    const url = this.apiUrl + '/api/triggerdefinition/' + id;
    return this.httpclient.delete<any>(url)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  private handleError(error: any) {
    throw error;
    return error;
  }

}
